// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5u-2";
export var blackBorderOnHover = "_5u-7";
export var cell = "_5u-6";
export var cellContainer = "_5u-3";
export var checked = "_5u-8";
export var disabled = "_5u-5";
export var featuredIconCellContainer = "_5u-9";
export var featuredIconTextContainer = "_5u-b";
export var featuredIconWrapper = "_5u-a";
export var noBorder = "_5u-c";
export var orangeSelectedRow = "_ck-3";
export var overflowableText = "_5u-0";
export var overflowableTextContainer = "_5u-1";
export var row = "_5t-0";
export var rowCheckboxCell = "_5u-4";
export var selectableTable = "_ck-2";